export default __webpack_public_path__ + "static/media/stop-priority.ae5ea598.svg";